const firebaseConfig = {
    apiKey: "AIzaSyAWKh0CkqPE__JuOSohU_lyBzcDtr8klRs",
    authDomain: "assignment-11-website.firebaseapp.com",
    projectId: "assignment-11-website",
    storageBucket: "assignment-11-website.appspot.com",
    messagingSenderId: "722777929358",
    appId: "1:722777929358:web:a04391adea0e6173e4fbdf"
};

export default firebaseConfig;